import { FormControl, FormGroup } from '@angular/forms';

export type AdminInvoiceSettingsFormControls = {
  sendToKsef: FormControl<boolean | null>;
  seller: FormControl<string | null>;
  temporaryInvoiceBankName: FormControl<string | null>;
  temporaryInvoiceAccount: FormControl<string | null>;
};

export class AdminInvoiceSettingsFormData {
  public static SellerMaxLength = 255;
  public static TemporaryInvoiceBankNameMaxLength = 255;
  public static TemporaryInvoiceAccountMaxLength = 255;

  public constructor(
    private readonly data: {
      isConnectedWithKsef: boolean;
      sendToKsef: boolean;
      seller: string;
      temporaryInvoiceBankName: string;
      temporaryInvoiceAccount: string;
    },
  ) {}

  public get isConnectedWithKsef(): boolean {
    return this.data.isConnectedWithKsef;
  }

  public get sendToKsef(): boolean {
    return this.data.sendToKsef;
  }

  public get seller(): string {
    return this.data.seller;
  }

  public get temporaryInvoiceBankName(): string {
    return this.data.temporaryInvoiceBankName;
  }

  public get temporaryInvoiceAccount(): string {
    return this.data.temporaryInvoiceAccount;
  }
}

/* prettier-ignore */
export type AdminInvoiceSettingsFormGroup = FormGroup<AdminInvoiceSettingsFormControls>;
